// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ENTERPRISE UI KIT — opt-in, scoped under .ent
   Stripe/Linear-grade re-skin for the 4 redesigned pages ONLY.
   Does NOT touch global styles. Wrap a page in <div className="ent ent-page">.
   Dark-mode aware via [data-theme="dark"] on the document root.
   ============================================================ */

.ent {
  /* Mapped onto the global design tokens (redesign.css :root) so the kit
     inherits the 2026-06 brand look. Keep the --ent-* names stable. */
  /* Surfaces */
  --ent-bg: var(--bg-app);
  --ent-card: var(--surface);
  --ent-card-alt: var(--surface-2);
  --ent-border: var(--line);
  --ent-border-strong: var(--line-strong);

  /* Text */
  --ent-text: var(--t-900);
  --ent-text-2: var(--t-700);
  --ent-muted: var(--t-500);

  /* Brand primary action */
  --ent-primary: var(--brand-600);
  --ent-primary-hover: var(--brand-700);
  --ent-on-primary: #ffffff;

  /* Status — base / soft / ink trios */
  --ent-green: var(--ok-ink);
  --ent-green-bg: var(--ok-soft);
  --ent-amber: var(--warn-ink);
  --ent-amber-bg: var(--warn-soft);
  --ent-red: var(--err-ink);
  --ent-red-bg: var(--err-soft);
  --ent-neutral: var(--t-500);
  --ent-neutral-bg: var(--bg-inset);
  --ent-blue: var(--info-ink);

  /* Geometry */
  --ent-radius: var(--r-md);
  --ent-radius-sm: var(--r-sm);
  --ent-radius-pill: var(--r-pill);
  --ent-shadow: var(--sh-card);

  --ent-font-num: var(--font-mono);
}

[data-theme="dark"] .ent {
  --ent-bg: #0c0e13;
  --ent-card: #15181f;
  --ent-card-alt: #1a1e26;
  --ent-border: #262b35;
  --ent-border-strong: #333a46;

  --ent-text: #f3f4f6;
  --ent-text-2: #aab0bd;
  --ent-muted: #767d8c;

  --ent-primary: #f3f4f6;
  --ent-primary-hover: #e2e4e9;
  --ent-on-primary: #15181f;

  --ent-green: #34d17e;
  --ent-green-bg: rgba(31, 157, 87, 0.16);
  --ent-amber: #e0a23a;
  --ent-amber-bg: rgba(196, 123, 10, 0.18);
  --ent-red: #f06868;
  --ent-red-bg: rgba(211, 58, 58, 0.18);
  --ent-neutral: #9aa1ae;
  --ent-neutral-bg: rgba(255, 255, 255, 0.06);
  --ent-blue: #5b8dff;

  --ent-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

/* Tabular figures everywhere inside the kit */
.ent,
.ent .ent-num {
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum' 1;
}

/* ---------- Page shell ---------- */
.ent-page {
  background: var(--ent-bg);
  color: var(--ent-text);
  min-height: 100%;
  padding: 24px;
  margin: -24px; /* bleed to fill the .page-content (24px) padding */
}

@media (max-width: 576px) {
  /* Drop the negative-margin bleed on phones. The bleed is tuned for the
     desktop .page-content padding; on mobile it over-pulls content past both
     viewport edges (clipping the page title, header buttons and KPI cards).
     Let .page-content's 16px padding provide the gutter instead. */
  .ent-page { padding: 0; margin: 0; }
  .payouts-page{padding:0px !important;}
}

/* ---------- Page header ---------- */
.ent-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.ent-page-head__title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ent-text);
  line-height: 1.2;
}

.ent-page-head__fresh {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  font-size: 13px;
  color: var(--ent-text-2);
  flex-wrap: wrap;
}

.ent-page-head__fresh .ent-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.ent-dot--live { background: var(--ent-green); }
.ent-dot--test { background: var(--ent-amber); }

.ent-page-head__sep { color: var(--ent-border-strong); }

.ent-page-head__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 576px) {
  .ent-page-head__actions { width: 100%; }
  .ent-page-head__actions .ent-btn { flex: 1 1; justify-content: center; }
}

/* ---------- Buttons ---------- */
.ent-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: 38px;
  padding: 0 16px;
  border-radius: var(--ent-radius);
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
  transition: transform 0.16s ease, background 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
  font-family: inherit;
}

.ent-btn svg { width: 16px; height: 16px; flex-shrink: 0; }
.ent-btn:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.25); }

.ent-btn-primary {
  background: var(--grad-primary);
  color: #ffffff;
  border-color: transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25), 0 8px 20px rgba(109, 93, 246, 0.35);
  border-radius: var(--r-md);
}
.ent-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25), 0 10px 24px rgba(109, 93, 246, 0.42);
}

.ent-btn-secondary {
  background: var(--surface);
  color: var(--t-700);
  border-color: var(--line);
}
.ent-btn-secondary:hover:not(:disabled) { border-color: var(--brand-400); color: var(--brand-700); }

.ent-btn-danger {
  background: var(--err);
  color: #fff;
  border-color: transparent;
}
.ent-btn-danger:hover:not(:disabled) { background: var(--err-ink); }

.ent-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ---------- KPI strip ---------- */
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 18px;
}

@media (max-width: 991px) { .kpi-strip { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 576px) { .kpi-strip { grid-template-columns: 1fr; } }

.kpi-card {
  background: var(--ent-card);
  border: 1px solid var(--ent-border);
  border-radius: var(--ent-radius);
  box-shadow: var(--sh-card);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kpi-card__label {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--ent-muted);
}

.kpi-card__valrow {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.kpi-card__value {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ent-text);
  font-variant-numeric: tabular-nums;
}

.kpi-card__sub {
  font-size: 12px;
  color: var(--ent-text-2);
}

/* ---------- Delta chip ---------- */
.delta-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--ent-radius-pill);
  font-variant-numeric: tabular-nums;
}
.delta-chip.pos { background: var(--ent-green-bg); color: var(--ent-green); }
.delta-chip.neg { background: var(--ent-red-bg); color: var(--ent-red); }
.delta-chip.neutral { background: var(--ent-neutral-bg); color: var(--ent-neutral); }

/* ---------- Filter tabs ---------- */
.filter-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.filter-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px;
  border-radius: var(--ent-radius-pill);
  border: 1px solid transparent;
  background: transparent;
  color: var(--ent-text-2);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  transition: background 0.15s, color 0.15s;
}
.filter-tab:hover { background: var(--ent-neutral-bg); color: var(--ent-text); }
.filter-tab.active {
  background: var(--ent-card);
  border-color: var(--ent-border-strong);
  color: var(--ent-text);
  font-weight: 600;
}

.filter-tab__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--ent-radius-pill);
  background: var(--ent-neutral-bg);
  color: var(--ent-text-2);
  font-size: 11px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.filter-tab.active .filter-tab__count {
  background: var(--ent-primary);
  color: var(--ent-on-primary);
}

.filter-tab--ghost {
  color: var(--ent-muted);
  border: 1px dashed var(--ent-border-strong);
}
.filter-tab--ghost:hover { color: var(--ent-text); background: transparent; }

.filter-tabs__spacer { flex: 1 1; }

/* ---------- Search ---------- */
.ent-search {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.ent-search svg {
  position: absolute;
  left: 11px;
  width: 15px;
  height: 15px;
  color: var(--ent-muted);
  pointer-events: none;
}
.ent-search input {
  height: 34px;
  width: 260px;
  max-width: 100%;
  padding: 0 12px 0 33px;
  border: 1px solid var(--line);
  border-radius: var(--ent-radius);
  background: var(--surface);
  color: var(--ent-text);
  font-size: 13px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}
.ent-search input::placeholder { color: var(--t-400); }
.ent-search input:focus { border-color: var(--brand-400); box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12); }

@media (max-width: 576px) {
  .ent-search { width: 100%; }
  .ent-search input { width: 100%; }
}

/* ---------- Pro table ---------- */
.pro-table-wrap {
  background: var(--ent-card);
  border: 1px solid var(--ent-border);
  border-radius: var(--ent-radius);
  overflow: unset;
}
.pro-table-wrap.po-table-wrap{
  overflow: scroll;
}
.pro-table {
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
}

.pro-table thead th {
  text-align: left;
  padding: 12px 16px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--ent-muted);
  background: var(--ent-card-alt);
  border-bottom: 1px solid var(--ent-border);
  white-space: nowrap;
}

.pro-table tbody td {
  padding: 12px 16px;
  font-size: 14px;
  color: var(--ent-text);
  border-bottom: 1px solid var(--ent-border);
  vertical-align: middle;
}
.pro-table-wrap.tx-results {
    border: none;
}
.pro-table tbody tr:last-child td { border-bottom: none; }
.pro-table tbody tr { transition: background 0.16s ease; }
.pro-table tbody tr:hover { background: var(--ent-card-alt); }

/* Checkbox column */
.pro-table .col-check { width: 40px; padding-right: 0; }
.pro-table .col-check input[type="checkbox"] {
  width: 16px; height: 16px; cursor: pointer; accent-color: var(--ent-primary);
}

/* Amount cell — right aligned, bold, with secondary sub-line */
.pro-table .amount-cell { text-align: right; }
.amount-cell__main {
  font-family: var(--font-mono);
  font-weight: 700;
  color: var(--ent-text);
  font-variant-numeric: tabular-nums;
}
.amount-cell__sub {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: var(--ent-muted);
  font-variant-numeric: tabular-nums;
}
.pro-table th.amount-cell { text-align: right; }

/* Generic two-line cell (primary + gray sub) */
.cell-2 { display: flex; flex-direction: column; gap: 2px; }
.cell-2__main { font-weight: 500; color: var(--ent-text); }
.cell-2__sub { font-size: 12px; color: var(--ent-muted); }

.mono { font-family: var(--font-mono); font-feature-settings: 'tnum' 1; letter-spacing: -0.01em; }
.text-muted-cell { color: var(--ent-muted); }

/* Kebab row menu trigger */
.row-kebab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px; height: 28px;
  border: none;
  background: transparent;
  color: var(--ent-muted);
  border-radius: var(--ent-radius-sm);
  cursor: pointer;
}
.row-kebab:hover { background: var(--ent-neutral-bg); color: var(--ent-text); }
.pro-table .col-kebab { width: 44px; text-align: right; }

/* ---------- Asset badge ---------- */
.asset-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.asset-badge__glyph {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}
.asset-badge__text { display: flex; flex-direction: column; gap: 1px; line-height: 1.2; }
.asset-badge__sym { font-size: 14px; font-weight: 600; color: var(--ent-text); }
.asset-badge__chain { font-size: 12px; color: var(--ent-muted); }

/* Pending asset: same diameter as the token logo it stands in for, so the
   logo column stays aligned down the table. Dashed and muted so it reads as
   an empty slot rather than a real asset. */
.asset-badge__pending-glyph {
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px dashed #eaebf3;
  color: var(--ent-muted);
}
.asset-badge__sym--pending { font-weight: 500; color: var(--ent-muted); }

/* ---------- Pager ---------- */
.pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid var(--ent-border);
  flex-wrap: wrap;
}
.pager__info {
  font-size: 13px;
  color: var(--ent-text-2);
  font-variant-numeric: tabular-nums;
}
.pager__pages { display: flex; align-items: center; gap: 4px; }
.pager__btn {
  min-width: 30px;
  height: 30px;
  padding: 0 7px;
  border: 1px solid var(--ent-border-strong);
  background: var(--ent-card);
  color: var(--ent-text-2);
  border-radius: var(--ent-radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
}
.pager__btn:hover:not(:disabled) { background: var(--ent-card-alt); color: var(--ent-text); }
.pager__btn:disabled { opacity: 0.4; cursor: not-allowed; }
.pager__btn.active {
  background: var(--ent-primary);
  border-color: var(--ent-primary);
  color: var(--ent-on-primary);
  font-weight: 600;
}
.pager__ellipsis { padding: 0 4px; color: var(--ent-muted); font-size: 13px; }

/* ---------- Mobile: table → stacked cards ---------- */
@media (max-width: 767px){
   .pro-table-wrap{
      overflow: scroll;
   }
}
@media (max-width: 576px) {
  .pro-table thead { display: none; }
  .pro-table, .pro-table tbody, .pro-table tr, .pro-table td { display: block; width: 100%; }
  .pro-table tbody tr {
    /* border: 1px solid var(--ent-border); */
    border-radius: var(--ent-radius);
    margin-bottom: 10px;
    padding: 6px 4px;
  }
  .pro-table tbody td {
    border-bottom: 1px solid var(--ent-border);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    text-align: right;
  }
  .pro-table tbody td:last-child { border-bottom: none; }
  .pro-table tbody td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--ent-muted);
    text-align: left;
  }
  .pro-table .amount-cell { text-align: left;width: 100%; display: inline-block; }
  .amount-cell__main{float: right;}
  .amount-cell__sub{text-align: right;}
  .pro-table .col-check, .pro-table .col-kebab { display: none; }
  .pro-table .asset-badge { margin-left: auto; }
  .pager { justify-content: center; }
  .cell-2__main{   overflow: unset;
   display: unset;
   -webkit-line-clamp: 2; /* number of lines to show */
           line-clamp: 2; 
   -webkit-box-orient: vertical;}
   .cell-2{overflow: scroll;}
   .inv-v2 .ptable tbody td{padding: 14px 10px !important;}
   .inv-v2 .doc-items{overflow: scroll;display: inline-block;}
   .inv-v2 .rail-sec + .rail-sec{overflow: scroll;}
   .inv-v2 .rise{overflow: scroll;}
   .inv-v2 .dl .v{   overflow: scroll;
   -webkit-box-orient: vertical;}
}

/* ---------- Reduced motion ---------- */
@media (prefers-reduced-motion: reduce) {
  .ent-btn, .pro-table tbody tr { transition: none; }
  .ent-btn-primary:hover:not(:disabled) { transform: none; }
}

/* ---------- Page head: eyebrow + subtitle ---------- */
.ent-page-head__eyebrow {
  display: block;
  margin-bottom: 4px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--brand-600);
}
.ent-page-head__subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ent-text-2);
  max-width: 62ch;
}

/* ---------- Stat cards ---------- */
.stat-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 18px;
}
/* Icon on its own line, then label, then figure — matching the transactions
   summary card, which is the reference for every stat card in the dashboard.
   Side by side, the icon centred itself against the whole text block and sat
   level with the figure rather than the label it belongs to.

   Every token carries a fallback. --ent-* are declared inside \`.ent\`, and the
   dashboard root is \`.home-page\` with no \`.ent\` ancestor, so on that page the
   background, border, radius and shadow all resolved to nothing and the cards
   rendered invisible against the grey page. */
.stat-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px 16px;
  background: var(--ent-card, var(--surface, #fff));
  border: 1px solid var(--ent-border, var(--line, #eaebf3));
  border-radius: var(--ent-radius, var(--r-lg, 16px));
  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));
}
/* The icon is the only colour on the card. Tinted fill, saturated glyph — a
   solid fill at this size reads as a button and invites a click that does
   nothing. */
.stat-card__icon {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: var(--r-md, 10px);
  display: grid;
  place-items: center;
}
.stat-card__icon svg { width: 17px; height: 17px; }
.stat-card--brand .stat-card__icon { background: var(--brand-100); color: var(--brand-600); }
.stat-card--ok    .stat-card__icon { background: var(--ok-soft);   color: var(--ok-ink); }
.stat-card--warn  .stat-card__icon { background: var(--warn-soft); color: var(--warn-ink); }
.stat-card--err   .stat-card__icon { background: var(--err-soft);  color: var(--err-ink); }
.stat-card--info  .stat-card__icon { background: var(--info-soft); color: var(--info-ink); }

.stat-card__body { min-width: 0; width: 100%; display: flex; flex-direction: column; gap: 2px; }
.stat-card__label {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ent-text-2, var(--t-500, #6c7189));
}
.stat-card__valrow { display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; }
.stat-card__value {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ent-text, var(--t-900, #0e1124));
  font-variant-numeric: tabular-nums;
}
.stat-card__chip {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ent-muted, var(--t-500, #6c7189));
  font-variant-numeric: tabular-nums;
}
.stat-card__chip--up { color: var(--ok-ink); font-weight: 600; }
.stat-card__chip--down { color: var(--err-ink); font-weight: 600; }
.stat-card__sub { font-size: 12px; color: var(--t-400, #9aa0b6); }

@media (max-width: 1100px) { .stat-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 560px) {
  .stat-card-grid { grid-template-columns: 1fr; gap: 12px; }
  .stat-card { padding: 16px; }
}

/* ---------- Filter tabs: underline variant ---------- */
/* Same tabs, sitting on the top edge of a table card instead of floating above
   it, so the rail carries the divider and the tabs carry the indicator. */
.filter-tabs--underline {
  gap: 4px;
  margin-bottom: 0;
  padding: 0 16px;
  border-bottom: 1px solid var(--ent-border, var(--line, #eaebf3));
}
.filter-tabs--underline .filter-tab {
  height: 46px;
  border-radius: 0;
  border: none;
  background: transparent;
  box-shadow: inset 0 -2px 0 transparent;
  padding: 0 6px;
  margin-right: 14px;
  transition: color 0.15s, box-shadow 0.15s;
}
.filter-tabs--underline .filter-tab:hover { background: transparent; color: var(--ent-text, var(--t-900, #0e1124)); }
.filter-tabs--underline .filter-tab.active {
  background: transparent;
  color: var(--brand-600);
  font-weight: 600;
  box-shadow: inset 0 -2px 0 var(--brand-600);
}
.filter-tabs--underline .filter-tab.active .filter-tab__count {
  background: var(--brand-100);
  color: var(--brand-700);
}
@media (max-width: 720px) {
  .filter-tabs--underline { padding: 0 12px; overflow-x: auto; flex-wrap: nowrap; }
  .filter-tabs--underline .filter-tab { margin-right: 8px; }
}

/* Corner affordance on a summary card. Only rendered when the caller supplies a
   destination, so it never promises navigation that does not exist. */
.stat-card { position: relative; }
.stat-card__go {
  position: absolute;
  top: 16px;
  right: 16px;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 1px solid var(--ent-border, var(--line, #eaebf3));
  border-radius: 50%;
  background: var(--ent-card, var(--surface, #fff));
  color: var(--ent-muted, var(--t-500, #6c7189));
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.stat-card__go:hover {
  border-color: var(--brand-400, #a99cff);
  color: var(--brand-600, #6d5df6);
  background: var(--brand-100, #ece9ff);
}
/* Keeps the value clear of the chevron. */
.stat-card--linked .stat-card__body { padding-right: 30px; }

/* Page-head eyebrow as a pill. It carries an icon now, so it needs a surface of
   its own rather than sitting as loose coloured text above the title. */
.ent-page-head__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px 4px 9px;
  border-radius: 999px;
  background: var(--brand-100, #ece9ff);
  color: var(--brand-700, #5847d6);
  font-size: 12.5px;
  font-weight: 600;
  margin-bottom: 10px;
}
.ent-page-head__eyebrow svg { width: 14px; height: 14px; }

/* A figure that carries its own warning, independent of the icon tint. */
.stat-card__value--err { color: var(--err-ink, #ce2649); }
.stat-card__value--ok { color: var(--ok-ink, #0a8f64); }
.stat-card__value--warn { color: var(--warn-ink, #b9760a); }

/* Optional sparkline flush along a stat card's bottom edge. The card reserves
   room for it only when one is supplied, so cards without stay as they were. */
.stat-card--charted { padding-bottom: 30px; }
.stat-card__chart {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30px;
  pointer-events: none;
  overflow: hidden;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.stat-card__chart svg { width: 100%; height: 100%; display: block; }
`, "",{"version":3,"sources":["webpack://./src/styles/enterprise.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE;sEACoE;EACpE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;EACzB,uCAAuC;;EAEvC,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;;EAEzB,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;EACrC,yBAAyB;;EAEzB,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;;EAE3B,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;;EAE5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;;EAE5B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;;EAEpB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;;EAEzB,oBAAoB;EACpB,uCAAuC;EACvC,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;;EAEnB,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;;EAEE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,aAAa,EAAE,mDAAmD;AACpE;;AAEA;EACE;;;mEAGiE;EACjE,YAAY,UAAU,EAAE,SAAS,EAAE;EACnC,cAAc,sBAAsB,CAAC;AACvC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,iBAAiB,4BAA4B,EAAE;AAC/C,iBAAiB,4BAA4B,EAAE;;AAE/C,sBAAsB,+BAA+B,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B,WAAW,EAAE;EACvC,mCAAmC,SAAO,EAAE,uBAAuB,EAAE;AACvE;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,yHAAyH;EACzH,oBAAoB;AACtB;;AAEA,eAAe,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAC1D,yBAAyB,aAAa,EAAE,8CAA8C,EAAE;;AAExF;EACE,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,wFAAwF;EACxF,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,0CAA0C,8BAA8B,EAAE,uBAAuB,EAAE;;AAEnG;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;AACA,uCAAuC,0BAA0B,EAAE;;AAEnE,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA,4BAA4B,aAAa,qCAAqC,EAAE,EAAE;AAClF,4BAA4B,aAAa,0BAA0B,EAAE,EAAE;;AAEvE;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;AACpC;AACA,kBAAkB,+BAA+B,EAAE,uBAAuB,EAAE;AAC5E,kBAAkB,6BAA6B,EAAE,qBAAqB,EAAE;AACxE,sBAAsB,iCAAiC,EAAE,yBAAyB,EAAE;;AAEpF,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;AACA,oBAAoB,iCAAiC,EAAE,sBAAsB,EAAE;AAC/E;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;AACA,2BAA2B,sBAAsB,EAAE,uBAAuB,EAAE;;AAE5E,uBAAuB,SAAO,EAAE;;AAEhC,iCAAiC;AACjC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,0DAA0D;AAC5D;AACA,iCAAiC,mBAAmB,EAAE;AACtD,0BAA0B,8BAA8B,EAAE,8CAA8C,EAAE;;AAE1G;EACE,cAAc,WAAW,EAAE;EAC3B,oBAAoB,WAAW,EAAE;AACnC;;AAEA,oCAAoC;AACpC;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,0CAA0C;EAC1C,sBAAsB;AACxB;AACA;IACI,YAAY;AAChB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,sBAAsB,iCAAiC,EAAE;AACzD,4BAA4B,+BAA+B,EAAE;;AAE7D,oBAAoB;AACpB,wBAAwB,WAAW,EAAE,gBAAgB,EAAE;AACvD;EACE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,gCAAgC;AAC9E;;AAEA,+DAA+D;AAC/D,0BAA0B,iBAAiB,EAAE;AAC7C;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;AACA,4BAA4B,iBAAiB,EAAE;;AAE/C,+CAA+C;AAC/C,UAAU,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3D,gBAAgB,gBAAgB,EAAE,sBAAsB,EAAE;AAC1D,eAAe,eAAe,EAAE,uBAAuB,EAAE;;AAEzD,QAAQ,6BAA6B,EAAE,+BAA+B,EAAE,uBAAuB,EAAE;AACjG,mBAAmB,uBAAuB,EAAE;;AAE5C,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;AACA,mBAAmB,iCAAiC,EAAE,sBAAsB,EAAE;AAC9E,wBAAwB,WAAW,EAAE,iBAAiB,EAAE;;AAExD,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACxF,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC/E,sBAAsB,eAAe,EAAE,uBAAuB,EAAE;;AAEhE;;4CAE4C;AAC5C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;AACzB;AACA,6BAA6B,gBAAgB,EAAE,uBAAuB,EAAE;;AAExE,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kCAAkC;AACpC;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;AACA,mCAAmC,+BAA+B,EAAE,sBAAsB,EAAE;AAC5F,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;AAC1D;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,mBAAmB,cAAc,EAAE,uBAAuB,EAAE,eAAe,EAAE;;AAE7E,wDAAwD;AACxD;GACG;MACG,gBAAgB;GACnB;AACH;AACA;EACE,mBAAmB,aAAa,EAAE;EAClC,6DAA6D,cAAc,EAAE,WAAW,EAAE;EAC1F;IACE,yCAAyC;IACzC,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;EACnB;EACA,iCAAiC,mBAAmB,EAAE;EACtD;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;EAClB;EACA,0BAA0B,gBAAgB,CAAC,WAAW,EAAE,qBAAqB,EAAE;EAC/E,mBAAmB,YAAY,CAAC;EAChC,kBAAkB,iBAAiB,CAAC;EACpC,+CAA+C,aAAa,EAAE;EAC9D,0BAA0B,iBAAiB,EAAE;EAC7C,SAAS,uBAAuB,EAAE;EAClC,iBAAiB,eAAe;GAC/B,cAAc;GACd,qBAAqB,EAAE,4BAA4B;WAC3C,aAAa;GACrB,4BAA4B,CAAC;GAC7B,QAAQ,gBAAgB,CAAC;GACzB,yBAAyB,6BAA6B,CAAC;GACvD,mBAAmB,gBAAgB,CAAC,qBAAqB,CAAC;GAC1D,8BAA8B,gBAAgB,CAAC;GAC/C,cAAc,gBAAgB,CAAC;GAC/B,kBAAkB,gBAAgB;GAClC,4BAA4B,CAAC;AAChC;;AAEA,yCAAyC;AACzC;EACE,gCAAgC,gBAAgB,EAAE;EAClD,wCAAwC,eAAe,EAAE;AAC3D;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;;;;;;;;8CAQ8C;AAC9C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,yDAAyD;EACzD,mDAAmD;EACnD,0DAA0D;AAC5D;AACA;;aAEa;AACb;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;AACA,uBAAuB,WAAW,EAAE,YAAY,EAAE;AAClD,qCAAqC,4BAA4B,EAAE,uBAAuB,EAAE;AAC5F,qCAAqC,0BAA0B,IAAI,oBAAoB,EAAE;AACzF,qCAAqC,4BAA4B,EAAE,sBAAsB,EAAE;AAC3F,qCAAqC,2BAA2B,GAAG,qBAAqB,EAAE;AAC1F,qCAAqC,4BAA4B,EAAE,sBAAsB,EAAE;;AAE3F,mBAAmB,YAAY,EAAE,WAAW,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/F;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;AACA,qBAAqB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACtF;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kCAAkC;AACpC;AACA,uBAAuB,oBAAoB,EAAE,gBAAgB,EAAE;AAC/D,yBAAyB,qBAAqB,EAAE,gBAAgB,EAAE;AAClE,kBAAkB,eAAe,EAAE,4BAA4B,EAAE;;AAEjE,6BAA6B,kBAAkB,gDAAgD,EAAE,EAAE;AACnG;EACE,kBAAkB,0BAA0B,EAAE,SAAS,EAAE;EACzD,aAAa,aAAa,EAAE;AAC9B;;AAEA,yDAAyD;AACzD;0EAC0E;AAC1E;EACE,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,4CAA4C,uBAAuB,EAAE,6CAA6C,EAAE;AACpH;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;EAChF,sCAAsC,iBAAiB,EAAE;AAC3D;;AAEA;sEACsE;AACtE,aAAa,kBAAkB,EAAE;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,kBAAkB;EAClB,iDAAiD;EACjD,8CAA8C;EAC9C,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,qCAAqC;AACvC;AACA,0CAA0C;AAC1C,sCAAsC,mBAAmB,EAAE;;AAE3D;wEACwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,8BAA8B,WAAW,EAAE,YAAY,EAAE;;AAEzD,yEAAyE;AACzE,yBAAyB,8BAA8B,EAAE;AACzD,wBAAwB,6BAA6B,EAAE;AACvD,0BAA0B,+BAA+B,EAAE;;AAE3D;+EAC+E;AAC/E,sBAAsB,oBAAoB,EAAE;AAC5C;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;AACA,wBAAwB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE","sourcesContent":["/* ============================================================\n   ENTERPRISE UI KIT — opt-in, scoped under .ent\n   Stripe/Linear-grade re-skin for the 4 redesigned pages ONLY.\n   Does NOT touch global styles. Wrap a page in <div className=\"ent ent-page\">.\n   Dark-mode aware via [data-theme=\"dark\"] on the document root.\n   ============================================================ */\n\n.ent {\n  /* Mapped onto the global design tokens (redesign.css :root) so the kit\n     inherits the 2026-06 brand look. Keep the --ent-* names stable. */\n  /* Surfaces */\n  --ent-bg: var(--bg-app);\n  --ent-card: var(--surface);\n  --ent-card-alt: var(--surface-2);\n  --ent-border: var(--line);\n  --ent-border-strong: var(--line-strong);\n\n  /* Text */\n  --ent-text: var(--t-900);\n  --ent-text-2: var(--t-700);\n  --ent-muted: var(--t-500);\n\n  /* Brand primary action */\n  --ent-primary: var(--brand-600);\n  --ent-primary-hover: var(--brand-700);\n  --ent-on-primary: #ffffff;\n\n  /* Status — base / soft / ink trios */\n  --ent-green: var(--ok-ink);\n  --ent-green-bg: var(--ok-soft);\n  --ent-amber: var(--warn-ink);\n  --ent-amber-bg: var(--warn-soft);\n  --ent-red: var(--err-ink);\n  --ent-red-bg: var(--err-soft);\n  --ent-neutral: var(--t-500);\n  --ent-neutral-bg: var(--bg-inset);\n  --ent-blue: var(--info-ink);\n\n  /* Geometry */\n  --ent-radius: var(--r-md);\n  --ent-radius-sm: var(--r-sm);\n  --ent-radius-pill: var(--r-pill);\n  --ent-shadow: var(--sh-card);\n\n  --ent-font-num: var(--font-mono);\n}\n\n[data-theme=\"dark\"] .ent {\n  --ent-bg: #0c0e13;\n  --ent-card: #15181f;\n  --ent-card-alt: #1a1e26;\n  --ent-border: #262b35;\n  --ent-border-strong: #333a46;\n\n  --ent-text: #f3f4f6;\n  --ent-text-2: #aab0bd;\n  --ent-muted: #767d8c;\n\n  --ent-primary: #f3f4f6;\n  --ent-primary-hover: #e2e4e9;\n  --ent-on-primary: #15181f;\n\n  --ent-green: #34d17e;\n  --ent-green-bg: rgba(31, 157, 87, 0.16);\n  --ent-amber: #e0a23a;\n  --ent-amber-bg: rgba(196, 123, 10, 0.18);\n  --ent-red: #f06868;\n  --ent-red-bg: rgba(211, 58, 58, 0.18);\n  --ent-neutral: #9aa1ae;\n  --ent-neutral-bg: rgba(255, 255, 255, 0.06);\n  --ent-blue: #5b8dff;\n\n  --ent-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n\n/* Tabular figures everywhere inside the kit */\n.ent,\n.ent .ent-num {\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: 'tnum' 1;\n}\n\n/* ---------- Page shell ---------- */\n.ent-page {\n  background: var(--ent-bg);\n  color: var(--ent-text);\n  min-height: 100%;\n  padding: 24px;\n  margin: -24px; /* bleed to fill the .page-content (24px) padding */\n}\n\n@media (max-width: 576px) {\n  /* Drop the negative-margin bleed on phones. The bleed is tuned for the\n     desktop .page-content padding; on mobile it over-pulls content past both\n     viewport edges (clipping the page title, header buttons and KPI cards).\n     Let .page-content's 16px padding provide the gutter instead. */\n  .ent-page { padding: 0; margin: 0; }\n  .payouts-page{padding:0px !important;}\n}\n\n/* ---------- Page header ---------- */\n.ent-page-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.ent-page-head__title {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ent-text);\n  line-height: 1.2;\n}\n\n.ent-page-head__fresh {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n  font-size: 13px;\n  color: var(--ent-text-2);\n  flex-wrap: wrap;\n}\n\n.ent-page-head__fresh .ent-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.ent-dot--live { background: var(--ent-green); }\n.ent-dot--test { background: var(--ent-amber); }\n\n.ent-page-head__sep { color: var(--ent-border-strong); }\n\n.ent-page-head__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 576px) {\n  .ent-page-head__actions { width: 100%; }\n  .ent-page-head__actions .ent-btn { flex: 1; justify-content: center; }\n}\n\n/* ---------- Buttons ---------- */\n.ent-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  height: 38px;\n  padding: 0 16px;\n  border-radius: var(--ent-radius);\n  font-size: 13.5px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  transition: transform 0.16s ease, background 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;\n  font-family: inherit;\n}\n\n.ent-btn svg { width: 16px; height: 16px; flex-shrink: 0; }\n.ent-btn:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.25); }\n\n.ent-btn-primary {\n  background: var(--grad-primary);\n  color: #ffffff;\n  border-color: transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25), 0 8px 20px rgba(109, 93, 246, 0.35);\n  border-radius: var(--r-md);\n}\n.ent-btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25), 0 10px 24px rgba(109, 93, 246, 0.42);\n}\n\n.ent-btn-secondary {\n  background: var(--surface);\n  color: var(--t-700);\n  border-color: var(--line);\n}\n.ent-btn-secondary:hover:not(:disabled) { border-color: var(--brand-400); color: var(--brand-700); }\n\n.ent-btn-danger {\n  background: var(--err);\n  color: #fff;\n  border-color: transparent;\n}\n.ent-btn-danger:hover:not(:disabled) { background: var(--err-ink); }\n\n.ent-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ---------- KPI strip ---------- */\n.kpi-strip {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n@media (max-width: 991px) { .kpi-strip { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 576px) { .kpi-strip { grid-template-columns: 1fr; } }\n\n.kpi-card {\n  background: var(--ent-card);\n  border: 1px solid var(--ent-border);\n  border-radius: var(--ent-radius);\n  box-shadow: var(--sh-card);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kpi-card__label {\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--ent-muted);\n}\n\n.kpi-card__valrow {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.kpi-card__value {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ent-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.kpi-card__sub {\n  font-size: 12px;\n  color: var(--ent-text-2);\n}\n\n/* ---------- Delta chip ---------- */\n.delta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: var(--ent-radius-pill);\n  font-variant-numeric: tabular-nums;\n}\n.delta-chip.pos { background: var(--ent-green-bg); color: var(--ent-green); }\n.delta-chip.neg { background: var(--ent-red-bg); color: var(--ent-red); }\n.delta-chip.neutral { background: var(--ent-neutral-bg); color: var(--ent-neutral); }\n\n/* ---------- Filter tabs ---------- */\n.filter-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.filter-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: var(--ent-radius-pill);\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--ent-text-2);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: inherit;\n  transition: background 0.15s, color 0.15s;\n}\n.filter-tab:hover { background: var(--ent-neutral-bg); color: var(--ent-text); }\n.filter-tab.active {\n  background: var(--ent-card);\n  border-color: var(--ent-border-strong);\n  color: var(--ent-text);\n  font-weight: 600;\n}\n\n.filter-tab__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: var(--ent-radius-pill);\n  background: var(--ent-neutral-bg);\n  color: var(--ent-text-2);\n  font-size: 11px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n.filter-tab.active .filter-tab__count {\n  background: var(--ent-primary);\n  color: var(--ent-on-primary);\n}\n\n.filter-tab--ghost {\n  color: var(--ent-muted);\n  border: 1px dashed var(--ent-border-strong);\n}\n.filter-tab--ghost:hover { color: var(--ent-text); background: transparent; }\n\n.filter-tabs__spacer { flex: 1; }\n\n/* ---------- Search ---------- */\n.ent-search {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n.ent-search svg {\n  position: absolute;\n  left: 11px;\n  width: 15px;\n  height: 15px;\n  color: var(--ent-muted);\n  pointer-events: none;\n}\n.ent-search input {\n  height: 34px;\n  width: 260px;\n  max-width: 100%;\n  padding: 0 12px 0 33px;\n  border: 1px solid var(--line);\n  border-radius: var(--ent-radius);\n  background: var(--surface);\n  color: var(--ent-text);\n  font-size: 13px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease;\n}\n.ent-search input::placeholder { color: var(--t-400); }\n.ent-search input:focus { border-color: var(--brand-400); box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12); }\n\n@media (max-width: 576px) {\n  .ent-search { width: 100%; }\n  .ent-search input { width: 100%; }\n}\n\n/* ---------- Pro table ---------- */\n.pro-table-wrap {\n  background: var(--ent-card);\n  border: 1px solid var(--ent-border);\n  border-radius: var(--ent-radius);\n  overflow: unset;\n}\n.pro-table-wrap.po-table-wrap{\n  overflow: scroll;\n}\n.pro-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-variant-numeric: tabular-nums;\n}\n\n.pro-table thead th {\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--ent-muted);\n  background: var(--ent-card-alt);\n  border-bottom: 1px solid var(--ent-border);\n  white-space: nowrap;\n}\n\n.pro-table tbody td {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: var(--ent-text);\n  border-bottom: 1px solid var(--ent-border);\n  vertical-align: middle;\n}\n.pro-table-wrap.tx-results {\n    border: none;\n}\n.pro-table tbody tr:last-child td { border-bottom: none; }\n.pro-table tbody tr { transition: background 0.16s ease; }\n.pro-table tbody tr:hover { background: var(--ent-card-alt); }\n\n/* Checkbox column */\n.pro-table .col-check { width: 40px; padding-right: 0; }\n.pro-table .col-check input[type=\"checkbox\"] {\n  width: 16px; height: 16px; cursor: pointer; accent-color: var(--ent-primary);\n}\n\n/* Amount cell — right aligned, bold, with secondary sub-line */\n.pro-table .amount-cell { text-align: right; }\n.amount-cell__main {\n  font-family: var(--font-mono);\n  font-weight: 700;\n  color: var(--ent-text);\n  font-variant-numeric: tabular-nums;\n}\n.amount-cell__sub {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--ent-muted);\n  font-variant-numeric: tabular-nums;\n}\n.pro-table th.amount-cell { text-align: right; }\n\n/* Generic two-line cell (primary + gray sub) */\n.cell-2 { display: flex; flex-direction: column; gap: 2px; }\n.cell-2__main { font-weight: 500; color: var(--ent-text); }\n.cell-2__sub { font-size: 12px; color: var(--ent-muted); }\n\n.mono { font-family: var(--font-mono); font-feature-settings: 'tnum' 1; letter-spacing: -0.01em; }\n.text-muted-cell { color: var(--ent-muted); }\n\n/* Kebab row menu trigger */\n.row-kebab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px; height: 28px;\n  border: none;\n  background: transparent;\n  color: var(--ent-muted);\n  border-radius: var(--ent-radius-sm);\n  cursor: pointer;\n}\n.row-kebab:hover { background: var(--ent-neutral-bg); color: var(--ent-text); }\n.pro-table .col-kebab { width: 44px; text-align: right; }\n\n/* ---------- Asset badge ---------- */\n.asset-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n.asset-badge__glyph {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n.asset-badge__text { display: flex; flex-direction: column; gap: 1px; line-height: 1.2; }\n.asset-badge__sym { font-size: 14px; font-weight: 600; color: var(--ent-text); }\n.asset-badge__chain { font-size: 12px; color: var(--ent-muted); }\n\n/* Pending asset: same diameter as the token logo it stands in for, so the\n   logo column stays aligned down the table. Dashed and muted so it reads as\n   an empty slot rather than a real asset. */\n.asset-badge__pending-glyph {\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px dashed #eaebf3;\n  color: var(--ent-muted);\n}\n.asset-badge__sym--pending { font-weight: 500; color: var(--ent-muted); }\n\n/* ---------- Pager ---------- */\n.pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-top: 1px solid var(--ent-border);\n  flex-wrap: wrap;\n}\n.pager__info {\n  font-size: 13px;\n  color: var(--ent-text-2);\n  font-variant-numeric: tabular-nums;\n}\n.pager__pages { display: flex; align-items: center; gap: 4px; }\n.pager__btn {\n  min-width: 30px;\n  height: 30px;\n  padding: 0 7px;\n  border: 1px solid var(--ent-border-strong);\n  background: var(--ent-card);\n  color: var(--ent-text-2);\n  border-radius: var(--ent-radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n  font-family: inherit;\n}\n.pager__btn:hover:not(:disabled) { background: var(--ent-card-alt); color: var(--ent-text); }\n.pager__btn:disabled { opacity: 0.4; cursor: not-allowed; }\n.pager__btn.active {\n  background: var(--ent-primary);\n  border-color: var(--ent-primary);\n  color: var(--ent-on-primary);\n  font-weight: 600;\n}\n.pager__ellipsis { padding: 0 4px; color: var(--ent-muted); font-size: 13px; }\n\n/* ---------- Mobile: table → stacked cards ---------- */\n@media (max-width: 767px){\n   .pro-table-wrap{\n      overflow: scroll;\n   }\n}\n@media (max-width: 576px) {\n  .pro-table thead { display: none; }\n  .pro-table, .pro-table tbody, .pro-table tr, .pro-table td { display: block; width: 100%; }\n  .pro-table tbody tr {\n    /* border: 1px solid var(--ent-border); */\n    border-radius: var(--ent-radius);\n    margin-bottom: 10px;\n    padding: 6px 4px;\n  }\n  .pro-table tbody td {\n    border-bottom: 1px solid var(--ent-border);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    text-align: right;\n  }\n  .pro-table tbody td:last-child { border-bottom: none; }\n  .pro-table tbody td::before {\n    content: attr(data-label);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--ent-muted);\n    text-align: left;\n  }\n  .pro-table .amount-cell { text-align: left;width: 100%; display: inline-block; }\n  .amount-cell__main{float: right;}\n  .amount-cell__sub{text-align: right;}\n  .pro-table .col-check, .pro-table .col-kebab { display: none; }\n  .pro-table .asset-badge { margin-left: auto; }\n  .pager { justify-content: center; }\n  .cell-2__main{   overflow: unset;\n   display: unset;\n   -webkit-line-clamp: 2; /* number of lines to show */\n           line-clamp: 2; \n   -webkit-box-orient: vertical;}\n   .cell-2{overflow: scroll;}\n   .inv-v2 .ptable tbody td{padding: 14px 10px !important;}\n   .inv-v2 .doc-items{overflow: scroll;display: inline-block;}\n   .inv-v2 .rail-sec + .rail-sec{overflow: scroll;}\n   .inv-v2 .rise{overflow: scroll;}\n   .inv-v2 .dl .v{   overflow: scroll;\n   -webkit-box-orient: vertical;}\n}\n\n/* ---------- Reduced motion ---------- */\n@media (prefers-reduced-motion: reduce) {\n  .ent-btn, .pro-table tbody tr { transition: none; }\n  .ent-btn-primary:hover:not(:disabled) { transform: none; }\n}\n\n/* ---------- Page head: eyebrow + subtitle ---------- */\n.ent-page-head__eyebrow {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--brand-600);\n}\n.ent-page-head__subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--ent-text-2);\n  max-width: 62ch;\n}\n\n/* ---------- Stat cards ---------- */\n.stat-card-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 18px;\n}\n/* Icon on its own line, then label, then figure — matching the transactions\n   summary card, which is the reference for every stat card in the dashboard.\n   Side by side, the icon centred itself against the whole text block and sat\n   level with the figure rather than the label it belongs to.\n\n   Every token carries a fallback. --ent-* are declared inside `.ent`, and the\n   dashboard root is `.home-page` with no `.ent` ancestor, so on that page the\n   background, border, radius and shadow all resolved to nothing and the cards\n   rendered invisible against the grey page. */\n.stat-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 14px 16px;\n  background: var(--ent-card, var(--surface, #fff));\n  border: 1px solid var(--ent-border, var(--line, #eaebf3));\n  border-radius: var(--ent-radius, var(--r-lg, 16px));\n  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));\n}\n/* The icon is the only colour on the card. Tinted fill, saturated glyph — a\n   solid fill at this size reads as a button and invites a click that does\n   nothing. */\n.stat-card__icon {\n  flex: none;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--r-md, 10px);\n  display: grid;\n  place-items: center;\n}\n.stat-card__icon svg { width: 17px; height: 17px; }\n.stat-card--brand .stat-card__icon { background: var(--brand-100); color: var(--brand-600); }\n.stat-card--ok    .stat-card__icon { background: var(--ok-soft);   color: var(--ok-ink); }\n.stat-card--warn  .stat-card__icon { background: var(--warn-soft); color: var(--warn-ink); }\n.stat-card--err   .stat-card__icon { background: var(--err-soft);  color: var(--err-ink); }\n.stat-card--info  .stat-card__icon { background: var(--info-soft); color: var(--info-ink); }\n\n.stat-card__body { min-width: 0; width: 100%; display: flex; flex-direction: column; gap: 2px; }\n.stat-card__label {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--ent-text-2, var(--t-500, #6c7189));\n}\n.stat-card__valrow { display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; }\n.stat-card__value {\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ent-text, var(--t-900, #0e1124));\n  font-variant-numeric: tabular-nums;\n}\n.stat-card__chip {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--ent-muted, var(--t-500, #6c7189));\n  font-variant-numeric: tabular-nums;\n}\n.stat-card__chip--up { color: var(--ok-ink); font-weight: 600; }\n.stat-card__chip--down { color: var(--err-ink); font-weight: 600; }\n.stat-card__sub { font-size: 12px; color: var(--t-400, #9aa0b6); }\n\n@media (max-width: 1100px) { .stat-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (max-width: 560px) {\n  .stat-card-grid { grid-template-columns: 1fr; gap: 12px; }\n  .stat-card { padding: 16px; }\n}\n\n/* ---------- Filter tabs: underline variant ---------- */\n/* Same tabs, sitting on the top edge of a table card instead of floating above\n   it, so the rail carries the divider and the tabs carry the indicator. */\n.filter-tabs--underline {\n  gap: 4px;\n  margin-bottom: 0;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--ent-border, var(--line, #eaebf3));\n}\n.filter-tabs--underline .filter-tab {\n  height: 46px;\n  border-radius: 0;\n  border: none;\n  background: transparent;\n  box-shadow: inset 0 -2px 0 transparent;\n  padding: 0 6px;\n  margin-right: 14px;\n  transition: color 0.15s, box-shadow 0.15s;\n}\n.filter-tabs--underline .filter-tab:hover { background: transparent; color: var(--ent-text, var(--t-900, #0e1124)); }\n.filter-tabs--underline .filter-tab.active {\n  background: transparent;\n  color: var(--brand-600);\n  font-weight: 600;\n  box-shadow: inset 0 -2px 0 var(--brand-600);\n}\n.filter-tabs--underline .filter-tab.active .filter-tab__count {\n  background: var(--brand-100);\n  color: var(--brand-700);\n}\n@media (max-width: 720px) {\n  .filter-tabs--underline { padding: 0 12px; overflow-x: auto; flex-wrap: nowrap; }\n  .filter-tabs--underline .filter-tab { margin-right: 8px; }\n}\n\n/* Corner affordance on a summary card. Only rendered when the caller supplies a\n   destination, so it never promises navigation that does not exist. */\n.stat-card { position: relative; }\n.stat-card__go {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: grid;\n  place-items: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid var(--ent-border, var(--line, #eaebf3));\n  border-radius: 50%;\n  background: var(--ent-card, var(--surface, #fff));\n  color: var(--ent-muted, var(--t-500, #6c7189));\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n.stat-card__go:hover {\n  border-color: var(--brand-400, #a99cff);\n  color: var(--brand-600, #6d5df6);\n  background: var(--brand-100, #ece9ff);\n}\n/* Keeps the value clear of the chevron. */\n.stat-card--linked .stat-card__body { padding-right: 30px; }\n\n/* Page-head eyebrow as a pill. It carries an icon now, so it needs a surface of\n   its own rather than sitting as loose coloured text above the title. */\n.ent-page-head__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 11px 4px 9px;\n  border-radius: 999px;\n  background: var(--brand-100, #ece9ff);\n  color: var(--brand-700, #5847d6);\n  font-size: 12.5px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.ent-page-head__eyebrow svg { width: 14px; height: 14px; }\n\n/* A figure that carries its own warning, independent of the icon tint. */\n.stat-card__value--err { color: var(--err-ink, #ce2649); }\n.stat-card__value--ok { color: var(--ok-ink, #0a8f64); }\n.stat-card__value--warn { color: var(--warn-ink, #b9760a); }\n\n/* Optional sparkline flush along a stat card's bottom edge. The card reserves\n   room for it only when one is supplied, so cards without stay as they were. */\n.stat-card--charted { padding-bottom: 30px; }\n.stat-card__chart {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 30px;\n  pointer-events: none;\n  overflow: hidden;\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n}\n.stat-card__chart svg { width: 100%; height: 100%; display: block; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
